import { motion } from "framer-motion";
import { Leaf, Hand, ChefHat, Flag } from "lucide-react";

const pillars = [
  { icon: Leaf, title: "100% Natural", desc: "Sin conservadores, sin químicos. Solo ingredientes reales del campo mexicano." },
  { icon: Hand, title: "Hecho a Mano", desc: "Cada frasco es elaborado artesanalmente en lotes pequeños con dedicación." },
  { icon: ChefHat, title: "Sabor Gourmet", desc: "Recetas desarrolladas por expertos para un perfil de sabor único e inigualable." },
  { icon: Flag, title: "Orgullo Mexicano", desc: "Celebramos la riqueza culinaria de México en cada ingrediente y cada frasco." },
];

const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.07 } } };
const itemVariants = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.35 } } };

export default function PorQuePuraMadre() {
  return (
    <section data-testid="por-que-section" className="relative py-24 md:py-32" style={{ backgroundColor: "#1A1A1A" }}>
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.4 }} className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Nuestra diferencia</p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F5F0] tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            No somos <span className="text-[#E07A5F]">una salsa más</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((pillar, i) => {
            const Icon = pillar.icon;
            return (
              <motion.div key={i} variants={itemVariants} className="group p-8 border border-white/5 hover:border-[#D4AF37]/30 bg-[#262626] transition-all duration-500" data-testid={`pillar-${i}`}>
                <div className="w-14 h-14 mb-6 flex items-center justify-center border border-[#D4AF37]/20 group-hover:bg-[#D4AF37]/10 transition-all duration-500">
                  <Icon size={26} strokeWidth={1.2} className="text-[#D4AF37]" />
                </div>
                <h3 className="text-xl font-semibold text-[#F5F5F0] mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>{pillar.title}</h3>
                <p className="text-sm text-[#A3A3A3] leading-relaxed">{pillar.desc}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
